// Map contract custom errors + common wallet errors -> friendly messages.

const CONTRACT_ERRORS = {
  OnlyOwner: "This action is restricted to the owner.",
  OnlyAdmin: "This action is restricted to the admin.",
  AlreadyRegistered: "This wallet is already registered.",
  NotRegistered: "Please register first.",
  InvalidPackage: "Invalid board selected.",
  AlreadyActive: "This board is already active.",
  PreviousNotActive: "Activate the previous board first.",
  TransferFailed: "USDT transfer failed. Check your balance and approval.",
  UserNotActive: "This board is not active yet.",
  NotEligible: "You are not eligible for this reward yet.",
  NoNewIncome: "No new income to claim right now.",
  NoIncomeToClaim: "Nothing available to claim.",
  AmountMustBePositive: "Amount must be greater than zero.",
  InsufficientPool: "Insufficient pool balance.",
  NoAutoUpgradePending: "No pending auto-upgrade for this board.",
  ZeroAddress: "Invalid address.",
  BelowMinimumWithdraw: "Your balance is below the minimum withdrawal amount.",
};

export function parseError(err) {
  if (!err) return "Something went wrong.";

  // User rejected
  const code = err.code;
  if (code === 4001 || code === "ACTION_REJECTED") {
    return "Transaction cancelled.";
  }

  // Try to read a known custom error name
  const blob =
    (err.error && err.error.message) ||
    err.reason ||
    err.data?.message ||
    err.message ||
    "";

  for (const name of Object.keys(CONTRACT_ERRORS)) {
    if (blob.includes(name)) return CONTRACT_ERRORS[name];
  }

  // ethers revert reason
  if (err.reason) {
    if (err.reason.includes("reentrant")) return "Please wait — a transaction is in progress.";
    return capitalize(err.reason);
  }

  if (blob.toLowerCase().includes("insufficient funds")) {
    return "Insufficient BNB for gas fees.";
  }
  if (blob.toLowerCase().includes("transfer amount exceeds balance")) {
    return "Insufficient USDT balance.";
  }
  if (blob.toLowerCase().includes("user denied") || blob.toLowerCase().includes("rejected")) {
    return "Transaction cancelled.";
  }

  return "Transaction failed. Please try again.";
}

function capitalize(s) {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}
